import { BloomUniversalGuestGate } from '@/modules/bloom-universal/components/BloomUniversalGuestGate';
import { BloomUniversalSpaceScreen } from '@/modules/bloom-universal';

/**
 * Public Bloom Universal space page — `/universal-space?id=…`.
 * Guests only (web).
 */
export default function UniversalSpaceRoute() {
  return (
    <BloomUniversalGuestGate>
      <BloomUniversalSpaceScreen />
    </BloomUniversalGuestGate>
  );
}
